import { useEffect, useState } from "react";
import type { IManufacturer, IResponseWithLoading } from "App/Modules/Models";
import type { IManufacturersRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "App/Modules/Services";

type ManufacturersRespose = IResponseWithLoading<IManufacturer[]>;

type UseManufacturersHook = (manufacturersRepository: IManufacturersRepository) => {
    manufacturers: ManufacturersRespose;
};

export const useManufacturers: UseManufacturersHook = (manufacturersRepository) => {
    const [manufacturers, setManufacturers] = useState<ManufacturersRespose>();

    useEffect(() => {
        const subscription = extendWithLoadingAndFail(manufacturersRepository.getManufacturers()).subscribe(
            (response: ManufacturersRespose) => {
                setManufacturers(response);
            },
            (error) => {
                setManufacturers(error);
            },
        );
        return () => {
            subscription.unsubscribe();
        };
    }, [manufacturersRepository]);

    return {
        manufacturers,
    };
};
